import React, { useState } from 'react';
import { TEMA } from '../theme';

// Längre text, som anteckningar och inklistrade listor, med radbrytningarna
// kvar. Över några rader visas början och en länk för att läsa resten.
export default function Langtext({ text, rader = 4, style }: { text: string; rader?: number; style?: React.CSSProperties }) {
  const [öppen, setÖppen] = useState(false);
  const lång = text.split('\n').length > rader || text.length > rader * 110;
  return (
    <div style={style}>
      <div style={{
        whiteSpace: 'pre-line',
        ...(lång && !öppen ? { display: '-webkit-box', WebkitLineClamp: rader, WebkitBoxOrient: 'vertical', overflow: 'hidden' } : {}),
      }}>
        {text}
      </div>
      {lång && (
        <button onClick={() => setÖppen(ö => !ö)} style={{
          background: 'none', border: 'none', padding: 0, marginTop: '4px', cursor: 'pointer',
          color: TEMA.accent, fontFamily: "'Inter', sans-serif", fontSize: '12.5px',
        }}>{öppen ? 'Visa mindre' : 'Visa mer'}</button>
      )}
    </div>
  );
}
